import { render, staticRenderFns } from "./original.vue?vue&type=template&id=f84d9b2c&scoped=true&"
import script from "./original.vue?vue&type=script&lang=js&"
export * from "./original.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84d9b2c",
  null
  
)

export default component.exports